(function(){
  "use strict";

  /* ============================================================
     CHECKOUT LINK
     On Shopify the theme sets window.PF_CHECKOUT to the product's
     add-to-cart URL, so this fills itself in. Anywhere else, paste
     your store's buy link between the quotes below.
     Empty means the button says "Checkout opening soon".
     ============================================================ */
  var CHECKOUT_URL = window.PF_CHECKOUT || "";

  var reduced = window.matchMedia
    && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- cadence hairline ---------- */
  var hair = document.getElementById("hair");
  if (hair) {
    var strip = "";
    for (var h = 0; h < 96; h++) { strip += "<i" + (h % 3 === 0 ? ' class="r"' : "") + "></i>"; }
    hair.innerHTML = strip;
  }

  /* ---------- cadence canvas ---------- */
  function tokens() {
    var cs = getComputedStyle(document.documentElement);
    return {
      frame: cs.getPropertyValue("--frame").trim() || "#FFFFFF",
      blue:  cs.getPropertyValue("--blue").trim()  || "#3D87FF",
      line:  cs.getPropertyValue("--line-soft").trim() || "#171E28"
    };
  }

  function makeCadence(canvas, getMult) {
    if (!canvas || !canvas.getContext) { return; }
    var ctx = canvas.getContext("2d");
    var phase = 0;

    function draw() {
      var dpr = window.devicePixelRatio || 1;
      var w = canvas.clientWidth, h = canvas.clientHeight;
      if (!w || !h) { return; }
      if (canvas.width !== Math.round(w * dpr)) {
        canvas.width  = Math.round(w * dpr);
        canvas.height = Math.round(h * dpr);
      }
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, w, h);

      var t = tokens();
      var m = getMult();
      var slot = 11, bw = 7;
      var n = Math.max(8, Math.floor(w / slot));
      var base = h - 12;

      ctx.fillStyle = t.line;
      ctx.fillRect(0, base + 5, w, 1);

      for (var i = 0; i < n; i++) {
        var isReal = (i % m === 0);
        var tall = isReal ? h - 18 : (h - 18) * 0.48;
        if (isReal) {
          ctx.fillStyle = t.frame;
          ctx.globalAlpha = 1;
        } else {
          ctx.fillStyle = t.blue;
          var d = ((i - phase) % n + n) % n;
          ctx.globalAlpha = reduced ? 0.6 : 0.36 + 0.5 * Math.max(0, 1 - d / 7);
        }
        ctx.fillRect(i * slot + 2, base - tall, bw, tall);
      }
      ctx.globalAlpha = 1;
    }

    draw();
    if (!reduced) { setInterval(function(){ phase = (phase + 1) % 4096; draw(); }, 90); }
    window.addEventListener("resize", draw);
    if (window.matchMedia) {
      var mq = window.matchMedia("(prefers-color-scheme: dark)");
      if (mq.addEventListener) { mq.addEventListener("change", draw); }
    }
    new MutationObserver(draw).observe(document.documentElement,
      { attributes: true, attributeFilter: ["data-theme"] });
  }

  makeCadence(document.getElementById("heroCad"), function(){ return 3; });

  /* ---------- hero counter ---------- */
  var heroFps = document.getElementById("heroFps");
  if (heroFps) {
    var from = 58, to = 174;
    if (reduced) {
      heroFps.textContent = to;
    } else {
      var t0 = null;
      var ramp = function(ts) {
        if (t0 === null) { t0 = ts; }
        var p = Math.min(1, (ts - t0) / 1500);
        var e = 1 - Math.pow(1 - p, 3);
        heroFps.textContent = Math.round(from + (to - from) * e);
        if (p < 1) { requestAnimationFrame(ramp); }
        else {
          setInterval(function(){
            heroFps.textContent = to + (Math.random() < 0.35 ? (Math.random() < 0.5 ? -1 : 1) : 0);
          }, 700);
        }
      };
      requestAnimationFrame(ramp);
    }
  }

  /* ---------- the lab ---------- */
  var VRAM = [4, 6, 8, 10, 12, 16, 24];
  var mult = 3;

  var fpsIn = document.getElementById("fps");
  var vramIn = document.getElementById("vram");
  var fpsV = document.getElementById("fpsV");
  var vramV = document.getElementById("vramV");
  var outFps = document.getElementById("outFps");
  var outBase = document.getElementById("outBase");
  var outGen = document.getElementById("outGen");
  var outAll = document.getElementById("outAll");
  var riskF = document.getElementById("riskF");
  var riskL = document.getElementById("riskL");
  var vEl = document.getElementById("verdict");
  var vTag = document.getElementById("vTag");
  var vText = document.getElementById("vText");
  var multsEl = document.getElementById("mults");

  makeCadence(document.getElementById("labCad"), function(){ return mult; });

  function verdictFor(base, vram, m) {
    /* Each factor scores 0 (fine) to 3 (bad). The worst one leads the advice. */
    var mScore = m <= 3 ? 0 : (m === 4 ? 2 : 3);
    var vScore = vram >= 12 ? 0 : (vram >= 8 ? 1 : (vram >= 6 ? 2 : 3));
    var bScore = base >= 50 ? 0 : (base >= 35 ? 1 : (base >= 25 ? 2 : 3));

    /* low VRAM and a high multiplier compound each other */
    var risk = Math.min(100, (mScore * 20) + (vScore * 22) + (bScore * 16)
                            + (vScore >= 2 && m >= 4 ? 14 : 0));
    var tone = risk < 30 ? "good" : (risk < 62 ? "heat" : "stop");
    var tag, text;

    if (vScore === 3) {
      tag = "Not enough VRAM";
      text = "<b>" + vram + "&nbsp;GB is below what frame generation needs.</b> The generated frames have "
           + "nowhere to live, so you would get stutter rather than smoothness. If you try it anyway, stay "
           + "at 2&times; and turn your textures down first.";
    } else if (bScore === 3) {
      tag = "Base too low";
      text = "<b>At " + base + "&nbsp;fps there is not enough to build on.</b> Multiplying it makes the "
           + "picture move more, but the game still feels like " + base + "&nbsp;fps in your hands. Turn "
           + "in-game settings down until you are nearer 50&nbsp;fps, then come back.";
    } else if (m >= 5) {
      tag = "Too high";
      text = "<b>We do not recommend " + m + "&times; to anyone.</b> The frames stop feeling connected to "
           + "your input and most games start to judder. Drop to 3&times;, because you get a smoother "
           + "result from a lower number.";
    } else if (m === 4 && vScore >= 2) {
      tag = "Back it off";
      text = "<b>4&times; on " + vram + "&nbsp;GB is asking a lot.</b> This combination is where stutter "
           + "usually shows up. Try 2&times; or 3&times; first, and only come back up if it stays clean.";
    } else if (m === 4) {
      tag = "Worth a try";
      text = "<b>4&times; is fine in some games and too much in others.</b> Give it a go, but the moment "
           + "the pacing goes uneven, drop to 3&times; and leave it there.";
    } else if (bScore >= 1 || vScore >= 1) {
      tag = "Good to go";
      text = "<b>Around " + Math.round(base * m) + "&nbsp;fps at " + m + "&times;.</b> You are in the safe "
           + "range. With " + vram + "&nbsp;GB you have room for this multiplier, and switching FreeSync "
           + "or G-Sync on will clean up whatever judder is left.";
    } else {
      tag = "Ideal setup";
      text = "<b>Around " + Math.round(base * m) + "&nbsp;fps at " + m + "&times;.</b> Healthy base frame "
           + "rate, plenty of VRAM, sensible multiplier. This is exactly the case Framegen was built for. "
           + "Turn on FreeSync or G-Sync and enjoy it.";
    }
    return { risk: risk, tone: tone, tag: tag, text: text };
  }

  function refresh() {
    if (!fpsIn || !vramIn) { return; }
    var base = parseInt(fpsIn.value, 10);
    var vram = VRAM[parseInt(vramIn.value, 10)];

    fpsV.textContent = base;
    vramV.textContent = vram;
    outFps.textContent = Math.round(base * mult);
    outBase.textContent = base;
    outGen.textContent = mult - 1;
    outAll.textContent = mult;

    var v = verdictFor(base, vram, mult);
    riskF.style.width = Math.max(6, v.risk) + "%";
    riskF.style.background = "var(--" + (v.tone === "good" ? "blue" : v.tone === "heat" ? "heat" : "stop") + ")";
    riskL.textContent = v.risk < 30 ? "Low" : (v.risk < 62 ? "Moderate" : "High");
    vEl.setAttribute("data-t", v.tone);
    vTag.textContent = v.tag;
    vText.innerHTML = v.text;
  }

  if (multsEl) {
    multsEl.addEventListener("click", function(e){
      var b = e.target.closest("button[data-m]");
      if (!b) { return; }
      mult = parseInt(b.getAttribute("data-m"), 10);
      var all = multsEl.querySelectorAll("button[data-m]");
      for (var i = 0; i < all.length; i++) {
        all[i].setAttribute("aria-pressed", all[i] === b ? "true" : "false");
      }
      refresh();
    });
  }
  if (fpsIn) { fpsIn.addEventListener("input", refresh); }
  if (vramIn) { vramIn.addEventListener("input", refresh); }
  refresh();



  /* ---------- buy button ---------- */
  var buy = document.getElementById("buyBtn");
  if (buy) {
    if (CHECKOUT_URL) {
      buy.setAttribute("href", CHECKOUT_URL);
      /* an external store opens in a new tab; our own cart stays in this one */
      if (/^https?:/i.test(CHECKOUT_URL)) {
        buy.setAttribute("target", "_blank");
        buy.setAttribute("rel", "noopener");
      }
    } else {
      buy.addEventListener("click", function(e){
        e.preventDefault();
        if (buy.dataset.busy) { return; }
        buy.dataset.busy = "1";
        var label = buy.textContent;
        buy.textContent = "Checkout opening soon";
        setTimeout(function(){ buy.textContent = label; delete buy.dataset.busy; }, 2000);
      });
    }
  }

  /* ---------- scroll reveal ---------- */
  var revs = document.querySelectorAll(".rev");
  if (reduced || !("IntersectionObserver" in window)) {
    for (var r = 0; r < revs.length; r++) { revs[r].classList.add("on"); }
  } else {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting) { en.target.classList.add("on"); io.unobserve(en.target); }
      });
    }, { rootMargin: "0px 0px -12% 0px" });
    for (var q2 = 0; q2 < revs.length; q2++) { io.observe(revs[q2]); }
  }
})();